import { useLayoutEffect, useRef, useState } from "react";

const TagList = ({ tags = [], maxLines = 2 }) => {
  const containerRef = useRef(null);
  const itemRefs = useRef([]);
  const [visibleCount, setVisibleCount] = useState(tags.length);

  useLayoutEffect(() => {
    if (!containerRef.current || tags.length === 0) {
      setVisibleCount(0);
      return;
    }

    const measure = () => {
      const lineTops = new Set();
      let lastVisibleIdx = tags.length;

      for (let i = 0; i < itemRefs.current.length; i++) {
        const el = itemRefs.current[i];
        if (!el) continue;
        const top = Math.round(el.offsetTop);
        lineTops.add(top);
        if (lineTops.size > maxLines) {
          lastVisibleIdx = i;
          break;
        }
      }
      setVisibleCount(lastVisibleIdx);
    };

    measure();

    const ro = new ResizeObserver(measure);
    ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, [tags, maxLines]);

  if (!tags || tags.length === 0) return null;

  const hiddenCount = Math.max(0, tags.length - visibleCount);

  return (
    <div
      ref={containerRef}
      className="relative flex flex-wrap gap-1 mt-0.5"
    >
      {tags.map((t, i) => {
        const isVisible = i < visibleCount;
        return (
          <span
            key={i}
            ref={(el) => (itemRefs.current[i] = el)}
            style={{
              backgroundColor: t.color,
              visibility: isVisible ? "visible" : "hidden",
              position: isVisible ? "static" : "absolute",
              pointerEvents: isVisible ? "auto" : "none",
            }}
            className="text-white text-[10px] leading-none rounded px-1.5 py-[3px] whitespace-nowrap"
          >
            {t.name}
          </span>
        );
      })}
      {hiddenCount > 0 && (
        <span
          className="bg-white text-gray-600 text-[10px] leading-none rounded px-1.5 py-[3px] border border-gray-200 cursor-help"
          title={tags
            .slice(visibleCount)
            .map((t) => t.name)
            .join("\n")}
        >
          +{hiddenCount}
        </span>
      )}
    </div>
  );
};

export default TagList;
